export const iconFontAwesomeConnectivityCloudArrowDown = (
	<i className="fa-solid fa-cloud-arrow-down"></i>
);
